module.exports = __webpack_public_path__ + "media/images/athletes/1863-6380461107ff07147a7cac3134c627e9.png";